// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"LoadingOverlay_loadingOverlay__SOsJu"};